<div class="container custom-font">
  <div class="row justify-content-center align-items-center background-image">
    <div class="center-block">
      <div class="card center-aligned">
        <div class="card-body bg-signin">
          <nh-alert type="danger" [isOpen]="showError">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                @if (showError === 'ERROR_LOGIN') {
                <span
                  >{{ "ERROR_LOGIN_PART1" | globalTranslate }}
                  <a [href]="ppUrl">{{
                    "ERROR_LOGIN_PART2" | globalTranslate
                  }}</a></span
                >
                } @if (showError !== 'ERROR_LOGIN') {
                <span [innerHTML]="showError | globalTranslate"></span>
                }
              </div>
            </div>
          </nh-alert>
          <div class="text-center login-icon-style">
            <img
              alt=""
              src="../../../assets/images/⚛️ icons-login-person.svg"
            />
          </div>
          <br />
          <h1 class="text-center login-header-style">
            {{ "TENNCARE_SIGNIN" | globalTranslate }}
          </h1>
          <br />
          <br />
          <form [formGroup]="SignInform">
            <div class="row g-3 justify-content-center align-items-center">
              <div class="col-12 col-md-5">
                <nh-field
                  [mandatory]="true"
                  [isRow]="true"
                  label="{{ 'LOGIN_USERNAME_EMAIL' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="userName"
                    formControlName="userName"
                    [attr.aria-label]="'LOGIN_USERNAME_EMAIL' | globalTranslate"
                    class="form-control"
                    placeholder="{{ 'LOGIN_USERNAME_EMAIL' | globalTranslate }}"
                    (keyup)="onEnter()"
                    required
                  />
                </nh-field>
              </div>
            </div>
            <div class="row g-3 justify-content-center align-items-center">
              <div class="col-12 col-md-5">
                <nh-field
                  [mandatory]="true"
                  [isRow]="true"
                  label="{{ 'PASSWORD' | globalTranslate }}"
                  class="label-section"
                >
                  <div class="password-eye">
                    <input
                      [type]="fieldTextType ? 'text' : 'password'"
                      class="form-control"
                      formControlName="password"
                      placeholder="{{ 'PASSWORD' | globalTranslate }}"
                      required
                    />
                    <button
                      type="button"
                      class="eye-icon"
                      tabindex="0"
                      (click)="toggleFieldTextType()"
                      (keydown.enter)="toggleFieldTextType()"
                      (keydown.space)="
                        $event.preventDefault(); toggleFieldTextType()
                      "
                      [attr.aria-label]="
                        fieldTextType
                          ? ('HIDE_PASSWORD' | globalTranslate)
                          : ('SHOW_PASSWORD' | globalTranslate)
                      "
                      [attr.aria-pressed]="fieldTextType"
                    >
                      <img
                        alt=""
                        aria-hidden="true"
                        src="assets/images/Icons/eye-outline-password.svg"
                      />
                    </button>
                  </div>
                </nh-field>
              </div>
            </div>
            <br />
            <div class="reCaptcha">
              <div class="row g-3 justify-content-center align-items-center">
                <div class="col-12 col-md-6 col-lg-5 captcha-container">
                  @if (isRecaptchaEnabled && loaderReady) {
                  <re-captcha
                    (resolved)="resolved($event)"
                    formControlName="recaptchaReactive"
                    [siteKey]="siteKey"
                  >
                  </re-captcha>
                  }
                </div>
              </div>
            </div>
          </form>
          <br />
          <div class="row justify-content-center">
            <div class="col-12 col-md-6 col-lg-5 loginButton">
              <button
                id="signIn"
                (click)="signin()"
                [disabled]="SignInform.status != 'VALID'"
                class="btn btn-block btn-primary"
              >
                {{ "LOGIN" | globalTranslate }}
              </button>
            </div>
          </div>
          <br />
          <br />
          <div class="col-12">
            <div id="menu">
              <span class="hover-red">
                <a
                  tabindex="0"
                  class="btn btn-link hover-red"
                  (click)="navigateToForgotPW()"
                  (keydown.enter)="navigateToForgotPW()"
                  (keydown.space)="
                    navigateToForgotPW(); $event.preventDefault()
                  "
                >
                  <span>{{ "FORGOT_PWD" | globalTranslate }}</span>
                </a>
              </span>
              <span
                class="hover-red"
                style="
                  border-left: solid 1px #d1d3d4;
                  border-right: solid 1px #d1d3d4;
                "
              >
                <a
                  tabindex="0"
                  class="btn btn-link hover-red"
                  (click)="navigateToForgotUserName()"
                  (keydown.enter)="navigateToForgotUserName()"
                  (keydown.space)="
                    navigateToForgotUserName(); $event.preventDefault()
                  "
                >
                  <span>{{ "FORGOT_USERNAME" | globalTranslate }}</span>
                </a>
              </span>
              <span class="hover-red">
                <a
                  tabindex="0"
                  class="btn btn-link hover-red"
                  (click)="navigateToCreateAccount()"
                  (keydown.enter)="navigateToCreateAccount()"
                  (keydown.space)="
                    navigateToCreateAccount(); $event.preventDefault()
                  "
                >
                  <span>{{ "CREATE_ACCOUNT" | globalTranslate }}</span>
                </a>
              </span>
            </div>
          </div>
          <div>
            <br />
            <hr />
          </div>
          <br />
          <div>
            <p class="warning">
              {{ "SIGNIN_WARNING_HEADING" | globalTranslate }}
            </p>
            <div class="warning-message">
              {{ "SIGNIN_WARNING" | globalTranslate }}
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</div>